import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environment/environment';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { ParticipateEventContextService } from '../../../participate-event-context.service';

/** When API returns open:false without a message body. */
export const PARTICIPATION_REGISTER_CLOSED_FALLBACK = 'Tilmelding er lukket for dette event.';

export function resolveEventGuidFromRouterOrWindow(service: ComponentDataSourceService): string | null {
  const router = service.injector.get(Router);
  const participateContext = service.injector.get(ParticipateEventContextService);
  return participateContext.resolveEventGuid(router);
}

/**
 * Backend GET /events/:guid/participation/register-open — same rules as join_event for registration.
 */
export function fetchParticipationRegisterOpen$(
  service: ComponentDataSourceService,
  _params?: LoadDataParams
): Observable<{ open: boolean; message: string | null }> {
  const eventGuid = resolveEventGuidFromRouterOrWindow(service);
  if (!eventGuid) {
    return of({ open: true, message: null });
  }
  return service.http
    .get<{ open?: boolean; message?: string }>(`${environment.apiUrl}/events/${eventGuid}/participation/register-open`)
    .pipe(
      map((res) => {
        if (res?.open === false) {
          const m = typeof res?.message === 'string' && res.message.trim() !== '' ? res.message.trim() : null;
          return { open: false, message: m };
        }
        return { open: true, message: null };
      }),
      catchError((err) => {
        console.warn('[participation_register_open] request failed → treat as open:', err?.message || err);
        return of({ open: true, message: null });
      })
    );
}

/**
 * Backend GET /events/:guid/participation/can-cancel — true when user may self-cancel.
 */
export function fetchParticipationCanCancel$(
  service: ComponentDataSourceService
): Observable<boolean> {
  const eventGuid = resolveEventGuidFromRouterOrWindow(service);
  if (!eventGuid) {
    return of(false);
  }
  return service.http
    .get<{ visible?: boolean; data?: { visible?: boolean } }>(
      `${environment.apiUrl}/events/${eventGuid}/participation/can-cancel`
    )
    .pipe(
      map((res) => res?.visible === true || res?.data?.visible === true),
      catchError((err) => {
        console.warn('[participation_can_cancel] request failed → treat as false:', err?.message || err);
        return of(false);
      })
    );
}
